import { EditOutlined } from '@ant-design/icons'
import { Button, InputNumber, Space, Typography } from 'antd'

import { EditableInput } from '@eastcoal/common/components/EditableInput'

import { AuctionDealInputProps } from './interface'

export const AuctionDealInput = ({
  className,
  originalValue,
  value,
  onChange
}: AuctionDealInputProps) => {
  return (
    <EditableInput
      value={value}
      getActionComponent={({ toggleActive }) => (
        <Space size='small'>
          <Button
            icon={<EditOutlined />}
            type='text'
            onClick={() => toggleActive()}
          />
          {originalValue !== value && (
            <Typography.Text type='secondary'>
              (原值 {originalValue}, 已更改)
            </Typography.Text>
          )}
        </Space>
      )}
      getInputComponent={({ value, onChange }) => (
        <InputNumber value={value} onChange={onChange} />
      )}
      getPreviewComponent={({ value }) => (
        <span className={className}>{value}</span>
      )}
      onConfirm={onChange}
    />
  )
}
